import client from './internal/httpClient';

export const listPlans  = ()     => client.get('/admin/plans/list');
export const savePlan   = (data) => client.post('/admin/plans/save', data);
export const deletePlan = (code) => client.post('/admin/plans/delete', { code });
